import React, { Component } from 'react'

import ContentInfo from '../_ContentInfo'
import Display from '../../../../../v2SPRINTA/atoms/Display'
import Button from '../../../../../v2SPRINTA/atoms/Button'
import { FormGroup, Text } from '../../../../../v2SPRINTA/atoms/Form'
import { Col, Row, Hidden } from '../../../../../v2SPRINTA/atoms/Grid'
import AspectRatio from '../../../../../SPRINTA/atoms/AspectRatio'

import ImageDropArea from '../../../../../SPRINTA/molecules/ImageDropArea-mobile'
import ImagePreview from '../../../../../SPRINTA/molecules/ImagePreview'

import { saveExperience, uploadImage, deleteImage } from '../../_utils'


class Midia extends Component {
    inputRefs = {}

    handleChange(target) {
        let experience = this.props.data.experience
        experience[target.name] = target.value
        
        this.props.setData({
            experience
        }, () => {
            if(['radio', 'select-one', 'checkbox'].indexOf(target.type) > -1)
            this.handleChanged(target)
        })
    }
    
    handleChanged(target) {
        this.validAndSaveField(target)
    }

    validAndSaveField(target) {
        const { name } = target

        if(this.hasFieldError[name] && this.hasFieldError[name]()) return;

        const form = {}
        form[name] = this.props.data.experience[name]

        let async = saveExperience(this.props.token, form)
        .then(resp => {})

        if(this.props.async) this.props.async(async)
    }

    hasFieldError = {
        cover: () => {
            if(!this.props.data.cover) {
                let error = "Envie uma imagem para capa"
                // this.cove.setError(error)

                return {
                    element: this.cover.refs.div,
                    error
                }
            }
            return false
        },
    }

    
    validate() {
        let errors = []

        Object.keys(this.hasFieldError).forEach(item => {
            let error = this.hasFieldError[item]();
            if(error)
            errors.push(error)
        })

        return errors
    }

    uploadImage(inx) {
        let data = null
        let images = this.props.data.images
        if(inx === 'cover') {
            data = this.props.data.cover
        } else {
            data = this.props.data.images[inx]
        }
        
        uploadImage(this.props.token, {
            file: data.uploadFile,
            isCover: inx === 'cover' ? 1 : 0,
            progress: progress => {
                data.progress = progress

                if(inx === 'cover') {
                    this.props.setData({
                        cover: data
                    })
                } else {
                    images[inx] = data
                    this.props.setData({
                        images
                    })
                }
            }
        })
        .then(resp => {
            data.status = 'done'
            data.url = data.url
            data.id = resp.id

            if(inx === 'cover') {
                this.props.setData({
                    cover: data
                })
            } else {
                images[inx] = data
                this.props.setData({
                    images
                })
            }
        })
    }

    removeImage(inx) {
        let id = null
        if(inx === 'cover') {
            id = this.props.data.cover.id
        } else {
            id = this.props.data.images[inx].id
        }

        deleteImage(this.props.token, id)

        let images = this.props.data.images
        let cover = this.props.data.cover

        let data = {
            image: null,
            status: 'loading',
            uploadFile: null,
            progress: 0,
            url: null
        }
        if(inx === 'cover') {
            cover = data
        } else {
            images[inx] = data
        }
        this.props.setData({
            images,
            cover
        })
    }

    handleSetImage(url, index) {}

    handleSetFile(files, index) {
        let images = this.props.data.images
        let cover = this.props.data.cover

        let data = {
            status: 'loading',
            uploadFile: files[0],
            progress: 0,
            url: null
        }
        
        if(index === 'cover') {
            cover = data
        } else {
            images[index] = data
        }

        this.props.setData({
            images,
            cover
        }, () => {
            this.uploadImage(index)
        })
    }

    inStep() {
        let { cover, images, video } = this.props.data
        return cover || video || images.length > 0 ? true  : false
    }

    render() {
        return (
            <ContentInfo
                title='Ilustre sua experiência com fotos incríveis'
                description='Envie fotos e mostre para seus participantes como a sua experiência pode ser incrível'
                steps={this.props.steps}>

                <Row>
                    <Col size='12'>
                        <FormGroup>
                            <Display size={3}>
                                Envie uma foto que retrate sua experiência
                            </Display>
                            <br />
                            Retrate sua experiência através de imagens que consigam transmitir aos participantes detalhes da mesma. Atenção: Sua imagem precisa ser no formato JPEG e de preferência no tamanho 1920x530px.
                        </FormGroup>
                    </Col>

                    <Col size='12'>
                        <FormGroup ref={ref => this.cover = ref}>
                            <AspectRatio style={{ padding: '19.5% 0' }}>
                                {this.ImageDropAreaPreview(this.props.data.cover, 'cover')}
                            </AspectRatio>
                        </FormGroup>
                    </Col>
                </Row>

                <Row justifyContent='center'>
                    <Col size='12'>
                        <FormGroup>
                            <Display size={3}>
                                Ilustre sua experiência com fotos de contexto
                            </Display>
                            <br />
                            Cadastre fotos que ilustram os detalhes de sua experiência, as pessoas que participam, como é a experiência em si, o local onde ocorre, etc.
                        </FormGroup>
                    </Col>

                    <Col size='4'>
                            <FormGroup>
                        <AspectRatio>
                                {this.ImageDropAreaPreview(this.props.data.images[0], 0)}
                        </AspectRatio>
                            </FormGroup>
                    </Col>
                    <Col size='4'>
                            <FormGroup>
                        <AspectRatio>
                                {this.ImageDropAreaPreview(this.props.data.images[1], 1)}
                        </AspectRatio>
                            </FormGroup>
                    </Col>
                    <Col size='4'>
                            <FormGroup>
                        <AspectRatio>
                                {this.ImageDropAreaPreview(this.props.data.images[2], 2)}
                        </AspectRatio>
                            </FormGroup>
                    </Col>
                    <Col size='4'>
                            <FormGroup>
                        <AspectRatio>
                                {this.ImageDropAreaPreview(this.props.data.images[3], 3)}
                        </AspectRatio>
                            </FormGroup>
                    </Col>
                    <Col size='4'>
                            <FormGroup>
                        <AspectRatio>
                                {this.ImageDropAreaPreview(this.props.data.images[4], 4)}
                        </AspectRatio>
                            </FormGroup>
                    </Col>
                    <Col size='4'>
                            <FormGroup>
                        <AspectRatio>
                                {this.ImageDropAreaPreview(this.props.data.images[5], 5)}
                        </AspectRatio>
                            </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col size='12'>
                        <FormGroup>
                            <Display size={3}>
                                Você possuí um video de sua experiência?
                            </Display>
                        </FormGroup>
                    </Col>
                    <Col size='12'>
                        <FormGroup>
                            <Text
                                label='URL do vídeo'
                                name="video"
                                ref='video'
                                value={this.props.data.experience.video || ''}
                                onChangeDOM={e => this.handleChanged(e.target)}
                                onChange={e => this.handleChange(e.target)}
                                />
                        </FormGroup>
                    </Col>
                </Row>

            </ContentInfo>
        )
    }

    ImageDropAreaPreview(image, inx) {
        if(image && (image.url || image.uploadFile))
        return (
            <ImagePreview
                image={image.url}
                status={image.status}
                progress={image.progress}
                file={image.uploadFile}
                imageURL={url => {
                    this.handleSetImage(url, inx)
                }}
                onRemove={() => {
                    this.removeImage(inx)
                }}
                textProgress={<Hidden sizes='sm xs'><p align='center'>Enviando imagem</p></Hidden>}
            />
        )

        if(inx === 'cover')
        return (
            <ImageDropArea
                componentes={{
                    drag: () => ( <Hidden sizes='xs sm'>Arraste a foto para este campo ou</Hidden> ),
                    drop: () => ( <Hidden sizes='sm xs'>Largar imagem aqui</Hidden> ),
                    find: () => ( <span><Button inline secondary>Procurar</Button></span>),
                }}
                files={ files => {
                    this.handleSetFile(files, inx)
                }}
            />
        )
        
        return (
            <ImageDropArea
                componentes={{
                    drag: () => ( <Hidden sizes='xs sm'>Arraste a foto para este campo ou</Hidden> ),
                    drop: () => ( <Hidden sizes='sm xs'>Largar imagem aqui</Hidden> ),
                    find: () => ( <Hidden sizes='sm xs'><Button inline secondary>Procurar</Button></Hidden>),
                }}
                files={ files => {
                    this.handleSetFile(files, inx)
                } }
            />
        )
    }

}

export default Midia


// WEBPACK FOOTER //
// ./src/App/pages/CreateExperience/Steps/Midia/index.js